// English UI texts, used with translate.js (see client/i18n.js)
export default {
  // header
  'app.signIn': 'Sign in with GitHub',
  'app.tagline':
    'Issues, pull requests and permissions come straight from GitHub.',
  'app.signOut': 'Sign out',
  'app.home': 'All repositories',
  'app.language': 'Language',
  'repo.switch': 'Switch repository',
  'repo.select': 'Select a repository',
  'repo.openOnGithub': 'Open {repo} on GitHub',
  'repo.loading': 'Loading repositories…',
  'repo.none': 'No repositories',
  'repo.noneHint':
    'Install the GitHub App on a repository you have access to, then reload.',
  'repo.list': 'Repositories',
  'repo.private': 'private',

  'task.createIssue': 'Create an issue from this task',
  'task.issueBody': 'From #{number}',
  'button.busy': 'Working…',

  // toolbar
  'filter.search': 'Filter by title or #number',
  'filter.searchHint': 'Filter by title, or #number for one issue',
  'filter.by': 'Filter by {name}',
  'filter.type': 'Type',
  'filter.assignee': 'Assignee',
  'filter.label': 'Label',
  'filter.milestone': 'Milestone',
  'filter.issues': 'Issues',
  'filter.pulls': 'Pull requests',
  'filter.unassigned': 'Unassigned',
  'filter.clear': 'Clear',
  'filter.clearHint': 'Remove all filters',
  'live.on': 'Live',
  'live.off': 'Offline',
  'live.onHint': 'Live updates connected',
  'live.offHint':
    'Live updates not connected, changes from others show after reload',
  'board.updating': 'Updating…',
  'board.loading': 'Loading board…',
  'board.configError': '{error}: using the default lanes',
  'board.refreshFailed': 'Refresh failed: {error}',

  // lanes
  'lane.cards': { 1: '{n} card', n: '{n} cards' },
  'lane.wip': 'WIP limit {wip}',
  'lane.newIssue': 'New issue in {lane}',
  'lane.newIssuePlaceholder': 'Issue title, Enter to create, Esc to close',
  'lane.done': '{name} · {days}d',
  'lane.doneHint': 'Closed in the last {days} days',

  // cards
  'card.creating': 'creating…',
  'card.openOnGithub': 'Open on GitHub',
  'card.open': 'Open #{number}',
  'card.comments': { 1: '{n} comment', n: '{n} comments' },
  'card.closes': 'Closes',
  'card.linkedPulls': 'Linked pull requests',
  'card.setMilestone': 'Set milestone',
  'card.applyLabels': 'Apply labels',
  'card.assign': 'Assign people',
  'card.assignHeading': 'Assign up to 10 people',
  'card.issue': 'Issue',
  'card.pull': 'Pull request',
  'state.open': 'Open',
  'state.closed': 'Closed',
  'state.merged': 'Merged',
  'state.draft': 'Draft',

  // pull requests
  'checks.SUCCESS': 'Checks passed',
  'checks.PENDING': 'Checks running',
  'checks.EXPECTED': 'Checks expected',
  'checks.FAILURE': 'Checks failing',
  'checks.ERROR': 'Checks errored',
  'review.APPROVED': 'Approved',
  'review.CHANGES_REQUESTED': 'Changes requested',
  'review.REVIEW_REQUIRED': 'Review required',
  'merge.method.merge': 'Create a merge commit',
  'merge.method.squash': 'Squash and merge',
  'merge.method.rebase': 'Rebase and merge',
  'merge.methodHint.merge':
    'All commits are added to the base branch via a merge commit',
  'merge.methodHint.squash':
    'The commits are combined into one commit on the base branch',
  'merge.methodHint.rebase':
    'The commits are rebased and added to the base branch',
  'merge.commits': {
    1: '{n} commit from {branch} into {base}',
    n: '{n} commits from {branch} into {base}',
  },
  'merge.deleteBranch': 'Delete branch {branch}',
  'merge.doneDeleted': 'Merged #{number} and deleted branch {branch}',
  'merge.waitForChecks': 'Wait for checks to pass',
  'merge.button': 'Merge',
  'merge.choose': 'Merge: choose a method',
  'merge.busy': 'Merging…',
  'merge.done': 'Merged #{number}',
  'merge.headMoved': 'The pull request changed, check it again',
  'merge.blocked.noWrite': 'No write access',
  'merge.blocked.disabled': 'Merging disabled for repo',
  'merge.blocked.draft': 'Draft',
  'merge.blocked.loading': 'Loading status…',
  'merge.blocked.checks': 'Checks not green',
  'merge.blocked.BEHIND': 'Branch is behind base',
  'merge.blocked.BLOCKED': 'Blocked by branch protection',
  'merge.blocked.DIRTY': 'Merge conflicts',
  'merge.blocked.UNKNOWN': 'Checking mergeability…',
  'merge.blocked.UNSTABLE': 'Checks not green',
  'rebase.button': 'Rebase branch',
  'rebase.hint':
    'Rebase {branch} onto {base}: GitHub can do it without conflicts',
  'rebase.busy': 'Rebasing…',
  'rebase.done': 'Rebased {branch} onto {base}',
  'branch.delete': 'Delete branch',
  'branch.deleteHint': 'Delete branch {branch}',
  'branch.deleting': 'Deleting…',
  'branch.deleted': 'Deleted branch {branch}',
  'branch.deleteFailed': 'Could not delete branch {branch}: {error}',
  'claude.title': 'Claude Code',
  'claude.cli': 'Claude in the terminal',
  'claude.cliHint': {
    issue: 'Work on #{number} with Claude Code in a terminal',
    pr: 'Review #{number} with Claude Code in a terminal',
    conflicts:
      'Resolve the merge conflicts of #{number} with Claude Code in a terminal',
  },
  'claude.vscode': 'Claude in VS Code',
  'claude.vscodeHint': {
    issue: 'Work on #{number} with Claude Code in VS Code',
    pr: 'Review #{number} with Claude Code in VS Code',
    conflicts:
      'Resolve the merge conflicts of #{number} with Claude Code in VS Code',
  },
  'pr.vscode': 'Check out in VS Code',
  'pr.vscodeHint': 'Check out in VS Code (GitHub Pull Requests extension)',
  'pr.copyBranch': 'Copy branch',
  'pr.copyBranchHint': 'Copy branch name: {branch}',
  'pr.copied': 'Copied',
  'pr.copyFailed': 'Could not copy: {error}',
  'pr.statusFailed': 'Could not load pull request status: {error}',

  // detail
  'detail.close': 'Close (Esc)',
  'detail.conversation': 'Conversation',
  'detail.filesChanged': 'Files changed',
  'diff.loading': 'Loading changes…',
  'diff.files': { 1: '{n} file changed', n: '{n} files changed' },
  'diff.commits': { 1: '{n} commit', n: '{n} commits' },
  'diff.pickCommit': 'Show changes from',
  'diff.allCommits': 'All commits',
  'diff.viewed': 'Viewed',
  'diff.viewedCount': '{viewed} / {total} viewed',
  'diff.changedSinceViewed': 'Changed since viewed',
  'diff.viewedFailed': 'Could not save Viewed: {error}',
  'diff.none': 'No changes',
  'diff.comments': { 1: '{n} comment', n: '{n} comments' },
  'diff.resolved': 'Resolved',
  'diff.notShown':
    'No diff shown: binary file, or too large for GitHub to send',
  'diff.viewOnGithub': 'View on GitHub',
  'diff.status.added': 'added',
  'diff.status.removed': 'removed',
  'diff.status.renamed': 'renamed',
  'diff.status.copied': 'copied',
  'diff.status.changed': 'changed',
  'detail.loading': 'Loading…',
  'detail.titleHint': 'Click to edit the title',
  'detail.opened': 'opened {time}',
  'detail.commented': 'commented {time}',
  'detail.edit': 'Edit',
  'detail.delete': 'Delete comment',
  'detail.deleteConfirm': 'Click again to delete the comment',
  'detail.deleteShort': 'Delete?',
  'detail.emptyComment': 'The comment is empty. Delete it?',
  'detail.keepEditing': 'Keep editing',
  'detail.saving': 'saving…',
  'detail.notSaved': 'not saved, edit to retry',
  'detail.lane': 'Lane',
  'detail.moveToLane': 'Move to lane',
  'detail.assignees': 'Assignees',
  'detail.noOne': 'No one',
  'detail.assignYourself': 'assign yourself',
  'detail.labels': 'Labels',
  'detail.noLabels': 'None yet',
  'detail.milestone': 'Milestone',
  'detail.noMilestone': 'No milestone',
  'detail.noMilestones': 'No milestones yet — ',
  'detail.createMilestone': 'create one',
  'detail.pullRequest': 'Pull request',
  'detail.development': 'Development',
  'detail.addComment': 'Add a comment',
  'detail.commentPlaceholder': 'Add your comment here… paste or drop images',
  'detail.comment': 'Comment',
  'detail.update': 'Update',
  'detail.closeIssue': 'Close issue',
  'detail.closeIssueHint': 'Close this issue as completed',
  'detail.reopenIssue': 'Reopen issue',
  'detail.closePr': 'Close pull request',
  'detail.closePrHint': 'Close this pull request without merging',
  'detail.reopenPr': 'Reopen pull request',
  'detail.noDescription': 'No description',
  'detail.createFailed': 'Could not create "{title}": {error}',

  // editor
  'editor.write': 'Write',
  'editor.writeHint': 'Edit the markdown',
  'editor.preview': 'Preview',
  'editor.previewHint': 'Show how the text will look',
  'editor.heading': 'Add heading text',
  'editor.bold': 'Add bold text',
  'editor.italic': 'Add italic text',
  'editor.quote': 'Add a quote',
  'editor.code': 'Add code',
  'editor.link': 'Add a link',
  'editor.bullets': 'Add a bulleted list',
  'editor.numbers': 'Add a numbered list',
  'editor.tasks': 'Add a task list',
  'editor.placeholder': 'Write markdown… paste or drop images',
  'editor.nothing': 'Nothing to preview',
  'editor.attach': 'Paste, drop, or click to add images',
  'editor.attachHint': 'Attach images',
  'editor.uploading': 'Uploading {n}…',
  'editor.notImage': '{name} is not an image',
  'editor.cancel': 'Cancel',
  'editor.cancelHint': 'Discard changes (Esc)',
  'editor.save': 'Save',
  'editor.saveHint': 'Save (Cmd/Ctrl+Enter)',
  'editor.saving': 'Saving…',

  // settings
  'settings.title': 'Settings',
  'settings.open': 'Settings: language, what cards show',
  'settings.laneWidth': 'Lane width',
  'settings.laneWidth.narrow': 'Narrow',
  'settings.laneWidth.normal': 'Normal',
  'settings.laneWidth.wide': 'Wide',
  'settings.claudeCliHint':
    'Button on open issues and pull requests that starts Claude Code in a terminal, in your clone of the repo. Works once you have sent a message in Claude Code on this computer.',
  'settings.claudeVscodeHint':
    'Button on open issues and pull requests that opens a Claude Code tab in the focused VS Code window (Claude Code extension)',
  'settings.board': 'Board',
  'settings.hideIssuesWithPr': 'Hide issues with an open pull request',
  'settings.hideIssuesWithPrHint':
    'The pull request card stands for the issue while it is open',
  'settings.cards': 'Cards show',
  'settings.cardLabels': 'Labels',
  'settings.cardLabelsHint':
    'Label pills on cards (they stay editable in the issue)',
  'settings.cardLinks': 'Linked issues and pull requests',
  'settings.cardLinksHint':
    'Pull requests linked to an issue, issues a pull request closes',
  'settings.cardVscodeHint':
    'Button on pull request cards to check out the branch in VS Code',
  'settings.cardCopyBranchHint':
    'Button on pull request cards to copy the branch name',
  'settings.local': 'Saved in this browser.',

  // timeline
  'event.assigned': '{actor} assigned {user}',
  'event.assignedSelf': '{actor} self-assigned this',
  'event.unassigned': '{actor} unassigned {user}',
  'event.unassignedSelf': '{actor} removed their assignment',
  'event.labelsAdded': '{actor} added {added}',
  'event.labelsRemoved': '{actor} removed {removed}',
  'event.labelsChanged': '{actor} added {added} and removed {removed}',
  'event.moved': '{actor} moved this from {from} to {to}',
  'event.movedTo': '{actor} moved this to {to}',
  'event.movedOut': '{actor} moved this out of {from}',
  'event.milestoned': '{actor} added this to the {milestone} milestone',
  'event.demilestoned': '{actor} removed this from the {milestone} milestone',
  'event.closed': '{actor} closed this',
  'event.closedCompleted': '{actor} closed this as completed',
  'event.closedNotPlanned': '{actor} closed this as not planned',
  'event.reopened': '{actor} reopened this',
  'event.merged': '{actor} merged this',
  'event.renamed': '{actor} changed the title {from} {to}',
  'event.referenced': '{actor} mentioned this in {source}',
  'event.approved': '{actor} approved these changes',
  'event.changesRequested': '{actor} requested changes',
  'event.reviewDismissed': '{actor} had a review dismissed',

  // menus
  'menu.filter': 'Filter',
  'menu.shiftHint': '⇧-click to select several',
  'menu.apply': 'Apply',
  'menu.applyHint': 'Apply the selection (Enter)',
  'menu.empty': 'Nothing found',

  // time
  'time.justNow': 'just now',
}
